export interface PillLayout {
  gridColumn: string;
  clipPath: string | undefined;
  contentPadStart: string | undefined;
  contentPadEnd: string | undefined;
}

/** Nächte eines Balkens und ob er am Wechseltag halb beginnt oder halb endet. */
export interface PillSpanShape {
  nights: number;
  hasTransitionIn: boolean;
  hasTransitionOut: boolean;
}

/**
 * Bewahrt die produktive Same-Day-Geometrie mit einer sichtbaren 4-px-Cream-Fuge. Admin-Kalender
 * und Gastportal teilen sie, damit ein Wechseltag überall gleich aussieht.
 */
export function computePillLayout(span: PillSpanShape, baseGridStart: number): PillLayout {
  const outExt = span.hasTransitionOut ? 1 : 0;
  const totalCells = span.nights + outExt;
  const cellPct = 100 / totalCells;
  const gap = 4;
  let clipPath: string | undefined;

  if (span.hasTransitionIn && outExt) {
    clipPath = `polygon(calc(${cellPct}% + ${gap}px) 0, calc(100% - ${gap}px) 0, calc(${100 - cellPct}% - ${gap}px) 100%, ${gap}px 100%)`;
  } else if (outExt) {
    clipPath = `polygon(0 0, calc(100% - ${gap}px) 0, calc(${100 - cellPct}% - ${gap}px) 100%, 0 100%)`;
  } else if (span.hasTransitionIn) {
    clipPath = `polygon(calc(${cellPct}% + ${gap}px) 0, 100% 0, 100% 100%, ${gap}px 100%)`;
  }

  return {
    gridColumn: `${baseGridStart} / span ${totalCells}`,
    clipPath,
    contentPadStart: span.hasTransitionIn ? `${cellPct}%` : undefined,
    contentPadEnd: outExt ? `${cellPct}%` : undefined,
  };
}
